import { useSyncExternalStore } from "react";
import { soundStore } from "./soundStore";

export const useSoundStore = () => {
  const state = useSyncExternalStore(soundStore.subscribe, () => soundStore.state);
  return state;
};
